/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m25.13 1c3.237 0 5.87 2.633 5.87 5.87v18.26c0 3.237-2.633 5.87-5.87 5.87h-18.26c-3.237 0-5.87-2.633-5.87-5.87v-18.26c0-3.237 2.633-5.87 5.87-5.87zm0 28c2.134 0 3.87-1.736 3.87-3.87v-12.391h-6.039c.466.992.735 2.094.735 3.261 0 4.244-3.452 7.696-7.696 7.696s-7.696-3.452-7.696-7.696c0-1.167.269-2.269.735-3.261h-6.039v12.391c0 2.134 1.736 3.87 3.87 3.87zm3.87-22.13c0-2.134-1.736-3.87-3.87-3.87h-14.826v7.739h.094c1.405-1.494 3.394-2.435 5.602-2.435s4.197.941 5.602 2.435h7.398zm-24.5-3.037c-.906.709-1.5 1.8-1.5 3.037v3.869h1.5zm3.804-.833h-1.434c-.127 0-.246.025-.37.037v7.702h1.804zm7.696 7.304c-3.141 0-5.696 2.555-5.696 5.696s2.555 5.696 5.696 5.696 5.696-2.555 5.696-5.696-2.555-5.696-5.696-5.696zm7-2.304v-1.5c0-.55.45-1 1-1h1.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1h-1.5c-.55 0-1-.45-1-1z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;